/**
 * CL-393A-FIX1 / CL-393C — Real estate property route constants.
 *
 * Route split (consolidation in progress):
 * - MY_PROPERTIES_LIST_PATH — portfolio list + add/edit/archive
 * - MY_PROPERTY_INTELLIGENCE_TOOLS_PATH — Property DNA / Market / Neighborhood tools (CL-371A–372A)
 * - buildPropertyWorkspacePath — per-property workspace (CL-393A, primary destination)
 */

import { buildPropertyWorkspacePath } from "./propertyIntelligenceWorkspace";

export const MY_PROPERTIES_LIST_PATH = "/client-portal/real-estate/properties";

/** Property Intelligence Tools — full DNA, market, neighbourhood research (until migrated into workspace). */
export const MY_PROPERTY_INTELLIGENCE_TOOLS_PATH = "/client-portal/real-estate/my-property";

/** @deprecated Internal alias — use MY_PROPERTY_INTELLIGENCE_TOOLS_PATH */
export const MY_PROPERTY_LEGACY_INTELLIGENCE_PATH = MY_PROPERTY_INTELLIGENCE_TOOLS_PATH;

function safeStr(value) {
  return String(value ?? "").trim();
}

function isActivePropertyRecord(record) {
  return safeStr(record?.status).toLowerCase() !== "archived";
}

/**
 * Dashboard / overview CTA target: list when no Firestore records; workspace when one clear primary exists.
 */
export function resolveRealEstatePropertyEntryPath({ firestoreProperties = [] } = {}) {
  const rows = (firestoreProperties || []).filter((p) => p?.id && isActivePropertyRecord(p));
  if (!rows.length) return MY_PROPERTIES_LIST_PATH;

  const primary = rows.find((p) => p.isPrimary) || rows[0];
  if (rows.length === 1 && primary?.id) {
    return buildPropertyWorkspacePath(primary.id);
  }
  return MY_PROPERTIES_LIST_PATH;
}

/**
 * Workspace path for a portfolio card when a Firestore property id exists.
 */
export function resolvePropertyCardWorkspacePath(property) {
  const id = safeStr(property?.id);
  if (!id || id === "__legacy_primary__" || property?.isLegacyVirtual) return null;
  return buildPropertyWorkspacePath(id);
}
